<template>
    <div class="mb-8">
        <h3 class="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
            Recent Payments
        </h3>
        <DataTable
            :items="payments"
            :columns="columns"
            :pagination="pagination"
            @routeChange="viewPayment"
            @pageChange="handlePageChange"
        >
            <template #status="{ item }">
                <span :class="getPaymentStatusClass(item.status)"
                    class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full">
                    {{ getPaymentStatus(item.status) }}
                </span>
            </template>
        </DataTable>
    </div>
</template>

<script setup>
import DataTable from '@/components/general/DataTable.vue';
import { useRouter } from 'vue-router';
import { ROUTES } from '@/router/routeNames';
import { getPaymentStatus, getPaymentStatusClass, columns } from '@/utils/payments';
import { formatCurrency, formatDate } from '@/utils';

const router = useRouter();
const emit = defineEmits(['pageChange']);

const props = defineProps({
  payments: {
    type: Array,
    required: true,
    default: () => []
  },
  pagination: {
    type: Object,
    required: false,
    default: () => ({
      current_page: 1,
      last_page: 1,
      from: 1,
      to: 10,
      total: 10
    })
  }
});



function viewPayment(paymentId) {
   router.push({name: ROUTES.ADMIN_PAYMENT, params: {id: paymentId}});
}




function handlePageChange(page) {
    emit('pageChange', page);
}
</script>
